import {SlamPointCloudEdit} from '@/admin/resources/slamPointClouds/SlamPointClouds';

export default {
  edit: SlamPointCloudEdit,
};
